import { render, staticRenderFns } from "./costFormatter.vue?vue&type=template&id=ec50117a&scoped=true&"
import script from "./costFormatter.vue?vue&type=script&lang=js&"
export * from "./costFormatter.vue?vue&type=script&lang=js&"
import style0 from "./costFormatter.vue?vue&type=style&index=0&id=ec50117a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec50117a",
  null
  
)

export default component.exports